//#region INTERFACE IEmailTester
export interface IEmailTester {
  status: string;
  errorMsg?: {
    code?: string;
    message?: string;
  };
}
//#endregion